import ds from 'designsystem';

const enlargeFont = (fontSize) => {
  const trimmedSize = fontSize.slice(0, -3);

  return `${trimmedSize * ds.get('metrics.textEnlarge')}rem`;
};

export default enlargeFont;



// WEBPACK FOOTER //
// ./src/common/methods/enlargeFont.js